module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hudiara/hudiara.component.css
// module id = ./src/app/hudiara/hudiara.component.css
// module chunks = main